// extracted by mini-css-extract-plugin
export default {"preguntaTexto":"Historico_preguntaTexto__TBMJV","actions":"Historico_actions__YnVLu"};